import React from "react";
import {Person} from "../../../services/interface/query/person";
import CriminalRecord from "./CriminalRecord";
import OffendedDemands from "./OffendedDemands";
import OffenderDemands from "./OffenderDemands";
import Complaints from "./Complaints";
import Supa from "./Supa";

interface Props {
    person?: Person;
    sri?: boolean;
}
export default function LegalInformation({sri, person}: Props): JSX.Element {
    return (
        <div className={'flex flex-col gap-3'}>
            <CriminalRecord {...{sri, person}}/>
            <OffendedDemands {...{sri, person}}/>
            <OffenderDemands  {...{sri, person}}/>
            <Complaints {...{sri, person}}/>
            <Supa {...{sri, person}}/>
        </div>
    )
}
